import UpcomingContributionView from './UpcomingContributionView';

export default UpcomingContributionView;
